import { List } from '../../newsletter/types/Newsletter';

export const fetchNewsletters = async () => {
  const response = window.NewsletterLists;

  const filteredResponse = response.lists.filter((list: List) => list.preview_url || list.image_url);

  const premiumList = filteredResponse.filter((list: List) => list.is_premium);
  const regularList = filteredResponse.filter((list: List) => !list.is_premium);

  return { regularList, premiumList };
};

export const fetchSubscribedNewsletters = async (): Promise<string[]> => {
  const crmUser = window.crm_user;

  if (crmUser && crmUser.mail) {
    return crmUser.mail.map((mailItem: { code: string }) => mailItem.code);
  }
  return [];
};
